import React, { FunctionComponent } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import "./header.css";
import { useWhiteLabelSetting } from "../WhiteLabelProvider";
import { useHelpDialogContext } from "./help/HelpDialogProvider";
import { useLingui } from "@lingui/react";

export interface Props {}

export const Header: FunctionComponent<Props> = () => {
  const { openDialog } = useHelpDialogContext();
  const {
    i18n: { locale },
  } = useLingui();
  const {
    params: { company },
    path,
  } = useRouteMatch<{ company: string; language: string }>();

  const applicationName = useWhiteLabelSetting("applicationName");
  return (
    <>
      <header>
        <div className={`logo logo_${locale}`}>
          <div className="applicName">{applicationName}</div>
          <div className="taal">
            <Link className="button buttontaal" to={path.replace(":company", company).replace(":language", "nl")}>
              <span>NL</span>
            </Link>
            <Link className="button buttontaal" to={path.replace(":company", company).replace(":language", "fr")}>
              <span>FR</span>
            </Link>
            <button className="button buttonhelp" onClick={() => openDialog()}>
              <span>?</span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

Header.displayName = "Header";
